import { createContext, useContext } from "react";
export var AuthContext = createContext(void 0);
export var useAuth = function () {
  return useContext(AuthContext);
};